import { render } from "./SignUp.vue?vue&type=template&id=3ec0fbda&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=3ec0fbda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ec0fbda"

export default script